module.exports = App.ApplicationAdapter = DS.ActiveModelAdapter.extend
  env:     Em.inject.service('environment')
  session: Em.inject.service()

  hostBinding: 'env.apiRoot'
  namespace: 'api'

  headers: (->
    token = @get('session.apiKey')
    api_version = 2
    # api_version = 2 if localStorage.getItem('NewApiVersion') == 'true'
    h = {
      'Authorization': "Token token=\"#{token}\"",
      'Accept': "application/vnd.smartomato.v#{api_version}"
    }
    if @get('session.currentMultilingualLanguage')
      h['X-Smartomato-Locale'] = @get('session.currentMultilingualLanguage')
    h
  ).property('session.apiKey', 'session.currentMultilingualLanguage')

  buildURL: ->
    if @get('singularResource') and arguments.length >= 2
      arguments[1] = undefined

    @_super(arguments...)

  find: (store, type, id)->
    if type.singularResource
      @ajax(@buildURL(type.typeKey, undefined), 'GET')
    else
      @_super.apply(this, arguments)
